import {
  Factory,
  type ID,
  type MonolithicBlock,
  type NodeItem,
  ProjectActions,
  selectBlockParent,
  selectBlocksByNode,
} from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import { getId } from '@store/utils'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { selectToEditBlock } from '@storeOld/reducers/canvas/canvas'
import { put, select } from 'redux-saga/effects'

// Тулбар блока и тулбар страницы добавляют блок одинаково: новый блок
// сразу уходит в редактирование названия. Различается только место —
// под выделенным блоком или в конце выделенной страницы.
export function* addBlock() {
  const { canvas }: AppState = yield select()
  const selectedBlockIds = canvas.block.ids
  const { selectedNodes } = canvas.node

  if (selectedBlockIds.length === 1) {
    yield* addBlockAfterBlock(selectedBlockIds[0])
    return
  }

  if (selectedNodes.length === 1) {
    yield* addBlockToNodeEnd(selectedNodes[0])
  }
}

function* addBlockAfterBlock(blockId: ID) {
  const { colorId }: MonolithicBlock = yield select(
    migrationProjectSelector.getProjectBlockOrSymbolData(blockId)
  )

  const nodeIds: ID[] = yield select(selectBlockParent(blockId))
  const nodeId = nodeIds[0]
  const blocksByNodeId: ID[] = yield select(selectBlocksByNode(nodeId))

  yield* insertBlock(nodeId, blocksByNodeId.indexOf(blockId) + 1, colorId)
}

function* addBlockToNodeEnd(nodeId: ID) {
  const node: NodeItem = yield select(
    migrationProjectSelector.getProjectNodeById(nodeId)
  )

  if (!node) {
    return
  }

  const blocksByNodeId: ID[] = yield select(selectBlocksByNode(nodeId))

  yield* insertBlock(nodeId, blocksByNodeId.length, node.colorId)
}

function* insertBlock(nodeId: ID, index: number, colorId: ID) {
  const id = getId()
  const block = Factory.block.monolithic({
    id,
    colorId,
  })

  yield put(
    commitProjectRequest(
      ProjectActions.blocks.add({
        items: [block],
        index,
        parents: [nodeId],
      })
    )
  )

  yield put(selectToEditBlock(id))
}
